<app-header-latest></app-header-latest>
<!-- HERO -->
 
<div class="academy-hero">
  <div class="container-wrapper">
    <div>
      <div class="section-eyebrow">🎓 LEARN HR OPERATIONS</div>
      <h1>The HR Academy<br><span style="color:#c7d2fe;">by NeoHRMZ</span></h1>
      <p>Free courses, certifications, and learning paths built by HR professionals — for HR professionals. Level up your team's skills at your own pace.</p>
      <div style="display:flex;gap:16px;flex-wrap:wrap;">
        <a href="#" class="btn btn-white">Browse All Courses</a>
        <a href="#" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.3);">View Certifications</a>
      </div>
    </div>
    <div>
      <div class="progress-widget">
        <div class="progress-widget__title">Your Learning Progress</div>
        <div class="progress-course">
          <div class="progress-course__name"><span>Payroll Fundamentals</span><span>82%</span></div>
          <div class="progress-course__bar"><div class="progress-course__fill" style="width:82%;"></div></div>
        </div>
        <div class="progress-course">
          <div class="progress-course__name"><span>GDPR for HR Teams</span><span>60%</span></div>
          <div class="progress-course__bar"><div class="progress-course__fill" style="width:60%;"></div></div>
        </div>
        <div class="progress-course">
          <div class="progress-course__name"><span>OKR Mastery</span><span>35%</span></div>
          <div class="progress-course__bar"><div class="progress-course__fill" style="width:35%;"></div></div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- CATEGORIES -->
<section class="academy-cats">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">📂 Topics</span>
      <h2 class="sec-h2">Learn by<br><span class="gradient-text">Category</span></h2>
    </div>
    <div class="cats-grid">
      <div class="cat-card"><div class="cat-card__icon">💰</div><div class="cat-card__title">Payroll &amp; Tax</div><div class="cat-card__count">24 courses</div></div>
      <div class="cat-card"><div class="cat-card__icon">⚖️</div><div class="cat-card__title">HR Compliance</div><div class="cat-card__count">18 courses</div></div>
      <div class="cat-card"><div class="cat-card__icon">🎯</div><div class="cat-card__title">Talent Acquisition</div><div class="cat-card__count">16 courses</div></div>
      <div class="cat-card"><div class="cat-card__icon">📈</div><div class="cat-card__title">Performance Management</div><div class="cat-card__count">12 courses</div></div>
      <div class="cat-card"><div class="cat-card__icon">🌍</div><div class="cat-card__title">Global HR</div><div class="cat-card__count">10 courses</div></div>
      <div class="cat-card"><div class="cat-card__icon">🤖</div><div class="cat-card__title">AI &amp; HR Tech</div><div class="cat-card__count">8 courses</div></div>
      <div class="cat-card"><div class="cat-card__icon">🤝</div><div class="cat-card__title">Employee Relations</div><div class="cat-card__count">14 courses</div></div>
      <div class="cat-card"><div class="cat-card__icon">📊</div><div class="cat-card__title">HR Analytics</div><div class="cat-card__count">9 courses</div></div>
    </div>
  </div>
</section>

<!-- COURSES -->
<section class="courses-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">⭐ Most Popular</span>
      <h2 class="sec-h2">Top Courses<br><span class="gradient-text">This Month</span></h2>
    </div>
    <div class="courses-grid">
      <div class="course-card">
        <div class="course-card__thumb" style="background:linear-gradient(135deg,#1e1b4b,#4338ca);">💰</div>
        <div class="course-card__body">
          <span class="course-card__level beginner">Beginner</span>
          <div class="course-card__title">Payroll 101: From Zero to First Run</div>
          <div class="course-card__meta"><span>⏱ 4h 30min</span><span>📚 12 lessons</span></div>
          <div class="course-card__footer">
            <span class="course-card__author">By Priya Agarwal</span>
            <span class="course-card__rating">★ 4.9</span>
          </div>
        </div>
      </div>
      <div class="course-card">
        <div class="course-card__thumb" style="background:linear-gradient(135deg,#083344,#0891b2);">⚖️</div>
        <div class="course-card__body">
          <span class="course-card__level intermediate">Intermediate</span>
          <div class="course-card__title">GDPR Compliance for HR Practitioners</div>
          <div class="course-card__meta"><span>⏱ 3h 15min</span><span>📚 9 lessons</span></div>
          <div class="course-card__footer">
            <span class="course-card__author">By James Thornton</span>
            <span class="course-card__rating">★ 4.8</span>
          </div>
        </div>
      </div>
      <div class="course-card">
        <div class="course-card__thumb" style="background:linear-gradient(135deg,#1e1b4b,#6366f1);">🎯</div>
        <div class="course-card__body">
          <span class="course-card__level advanced">Advanced</span>
          <div class="course-card__title">Strategic Talent Acquisition in 2025</div>
          <div class="course-card__meta"><span>⏱ 6h 00min</span><span>📚 18 lessons</span></div>
          <div class="course-card__footer">
            <span class="course-card__author">By Meera Rao</span>
            <span class="course-card__rating">★ 4.7</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- LEARNING PATHS -->
<section class="paths-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">🗺️ Structured Learning</span>
      <h2 class="sec-h2">Learning Paths<br><span class="gradient-text">by Role</span></h2>
    </div>
    <div class="paths-grid">
      <div class="path-card">
        <div class="path-card__badge">For HR Managers</div>
        <div class="path-card__title">Complete HR Operations</div>
        <div class="path-card__desc">From onboarding workflows to performance cycles and compliance — everything a modern HR manager needs in one structured path.</div>
        <div class="path-card__steps">
          <span class="path-card__step">Payroll Basics</span>
          <span class="path-card__step">Compliance 101</span>
          <span class="path-card__step">Talent Management</span>
          <span class="path-card__step">HR Analytics</span>
        </div>
      </div>
      <div class="path-card">
        <div class="path-card__badge">For Recruiters</div>
        <div class="path-card__title">Modern Talent Acquisition</div>
        <div class="path-card__desc">Sourcing strategies, employer branding, ATS mastery, and data-driven hiring decisions — the full recruiter toolkit.</div>
        <div class="path-card__steps">
          <span class="path-card__step">Job Design</span>
          <span class="path-card__step">Sourcing Tactics</span>
          <span class="path-card__step">Interview Skills</span>
          <span class="path-card__step">Offer Strategy</span>
        </div>
      </div>
      <div class="path-card">
        <div class="path-card__badge">For HR Business Partners</div>
        <div class="path-card__title">Strategic HR Leadership</div>
        <div class="path-card__desc">Workforce planning, OKR frameworks, organizational design, and partnering with the C-suite — for senior HR professionals.</div>
        <div class="path-card__steps">
          <span class="path-card__step">Org Design</span>
          <span class="path-card__step">OKR Mastery</span>
          <span class="path-card__step">Workforce Planning</span>
          <span class="path-card__step">Change Management</span>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- CERTIFICATIONS -->
<section class="certs-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">🏆 Certifications</span>
      <h2 class="sec-h2">Earn Credentials<br><span class="gradient-text">That Matter</span></h2>
    </div>
    <div class="certs-grid">
      <div class="cert-card">
        <div class="cert-card__icon">🏅</div>
        <div class="cert-card__title">Certified HR Operations Specialist</div>
        <div class="cert-card__desc">Master core HR operations: payroll, attendance, compliance, and employee lifecycle management with NeoHRMZ.</div>
        <div class="cert-card__tag">12 hours · Free</div>
      </div>
      <div class="cert-card">
        <div class="cert-card__icon">🎖️</div>
        <div class="cert-card__title">Global Payroll Professional</div>
        <div class="cert-card__desc">Multi-country payroll, FX management, statutory benefits, and cross-border compliance — advanced certification.</div>
        <div class="cert-card__tag">20 hours · Free</div>
      </div>
      <div class="cert-card">
        <div class="cert-card__icon">🥇</div>
        <div class="cert-card__title">HR Analytics &amp; Reporting Expert</div>
        <div class="cert-card__desc">Build dashboards, interpret workforce data, predict attrition, and present insights to executive leadership teams.</div>
        <div class="cert-card__tag">15 hours · Free</div>
      </div>
    </div>
  </div>
</section>

<!-- CTA -->
<section class="academy-cta">
  <div class="container-wrapper">
    <h2 class="academy-cta__h2">Start Learning for Free<br>Today</h2>
    <p class="academy-cta__p">Join 45,000+ HR professionals who are building better skills and advancing their careers with the NeoHRMZ Academy.</p>
    <div class="academy-cta__actions">
      <a href="#" class="btn btn-white">Create Free Account</a>
      <a href="#" class="btn btn-outline" style="color:#fff;border-color:rgba(255,255,255,0.3);">Browse All Courses</a>
    </div>
  </div>
</section>
<app-peopleflow-footer></app-peopleflow-footer>